<div class="header">
    <div class="logo">
        <a [routerLink]="['/']"><img src="/images/logo.svg" /></a>
    </div>
    <div class="menu">
        <a [routerLink]="['/']">Home</a>
        <a [routerLink]="['/blogs/']">Blogs</a>
        <a [routerLink]="['/about']">About</a>
    </div>
</div>

<div class="content-wrapper">
<router-outlet></router-outlet>
</div>